// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mg-mczx/static/js/" + chunkId + "." + {"257":"d7e95b09","407":"bf5537ca","564":"bb7e0aff","750":"61fb0f76"}[chunkId] + ".js";
};